// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"508":"7d5bc61d","786":"e8b60b3f","982":"d9be56c2"}[chunkId] + ".css";
};